/* src/app/ai-sourcing/share-project/share-project.component.scss */
.talentpool-chip {
  background-color: #e4f1f3;
  color: #484b59;
  border-radius: 16px;
  min-height: 32px;
  height: 1px;
  font-size: 12px;
  font-weight: 500;
}
.wc-checkbox {
  width: 15px !important;
  height: 15px !important;
  position: relative;
  left: 0;
  top: 3px;
  cursor: pointer;
}
.wc-checkbox input[type=checkbox] {
  left: 0;
  right: 0;
  width: 15px;
  height: 15px;
}
.wc-checkbox i {
  border: 1px solid #2e93a1;
  border-radius: 2px;
}
.border-unselected {
  border: 1px solid #e4f1f3 !important;
}
.border-selected {
  border: 1px solid #2E93A1 !important;
}
/*# sourceMappingURL=share-project.component-5Y5ZG3ZA.css.map */
